import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UILink from 'UIComponents/link/UILink';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { getInboxEditUrl } from '../../../urls/inbox-urls';
import { jsx as _jsx } from "react/jsx-runtime";
const RemovedFromInboxUserTooltip = ({
  children,
  inboxId
}) => /*#__PURE__*/_jsx(UITooltip, {
  placement: "top",
  title: /*#__PURE__*/_jsx(FormattedJSXMessage, {
    elements: {
      UILink
    },
    message: "routing-ui.routingRules.users.removedFromInbox_jsx",
    options: {
      external: true,
      href: getInboxEditUrl(inboxId)
    }
  }),
  children: children
});
RemovedFromInboxUserTooltip.displayName = 'RemovedFromInboxUserTooltip';
export default RemovedFromInboxUserTooltip;